import { WebsiteConfigExperimentVariant } from './webConfigExperiments'

export type StoredVariant = {
    identifiers: string[]
    variants: WebsiteConfigExperimentVariant['config'][]
}

const WEB_CONFIG_VARIANTS_STORAGE_KEY = 'WEB_CONFIG_VARIANTS'

export const validateStoredVariants = (possibleIdentifiers: string[], storedVariants: StoredVariant | null) =>
    storedVariants?.identifiers && storedVariants.identifiers.every((identifier) => possibleIdentifiers.includes(identifier))

export function getWebConfigStoredVariants(): StoredVariant | null {
    const variants = localStorage.getItem(WEB_CONFIG_VARIANTS_STORAGE_KEY)
    if (variants === null) {
        return null
    }
    return JSON.parse(variants)
}

export function storeWebConfigStoredVariants(variants: StoredVariant) {
    localStorage.setItem(WEB_CONFIG_VARIANTS_STORAGE_KEY, JSON.stringify(variants))
}
